import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=cafd397e&scoped=true&lang=html"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafd397e",
  null
  
)

export default component.exports